import "./OurWork.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ThePortfolio from "./sections/ThePortfolio";
import ClientVoices from "./sections/ClientVoices";
import StudioFooter from "@/reusable_sections/Footer";
export default function OurWorkPage() {
  return <div>
      <MainNavigation />
      <ThePortfolio />
      <ClientVoices />
      <StudioFooter />
    </div>;
}